export const ClientReview = [
  {
    title: "Coach Chris is extremely professional and very attentive",
    detail:
      "I have had personal training sessions with Coach Chris as well as his M2t blade and cupping treatments. Coach Chris is extremely professional and very attentive to even the smallest of detail of your body and form. He is also very patient. Training with Coach Chris has helped me improve my overall posture, strength and ease my back and neck pain from office syndrome and Scoliosis. Highly recommended! ",
  },
  {
    title: "Coach Chris is wonderful!",
    detail:
      "I have been training with Chris Pantony for the past two years, and believe he is one of the most experienced and committed trainers around.He works with my ability level to help me achieve my goals and always corrects to avoid any injuries.He also performs fantastic treatments with M2T-Blades.I highly recommend Chris as a trainer for all ages and skill levels.Thank you Chris. ",
  },
  {
    title: "Working out with Chris is 🔥!",
    detail:
      "A lovely chap, with years of experience, easily the best trainer I have ever worked with. The best thing is that I have actually got results, for the first time. Nothing beats seeing your body change for the better.  I couldn't be happier, highly recommended.",
  },
];
